import { designFastVariables } from "store/calculation.config";
import { parseVerticalPoints } from "utilities/geometricRoadutilities/parseVerticalPoints";

/*export const calculateSpeedAlongVerticalProfile = ({verticalGeometry, vehicle, speedlimit, initialSpeed}) => {

    const dt = 0.1;
    const geometry = parseVerticalPoints(verticalGeometry);

    let result = {
        forward:
        [
            {
                speed: initialSpeed ? initialSpeed : speedlimit,
                stationing:geometry[0].stationing
            }
        ],
        backward:
        [
            {
                speed:initialSpeed ? initialSpeed : speedlimit,
                stationing: geometry[geometry.length-1].stationing,
            }
        ]
    }

    console.log(speedlimit);

    while(result.forward[result.forward.length-1].stationing < geometry[geometry.length-1].stationing)
    {
        let currentObject = geometry.find(obj => obj.stationing >= result.forward[result.forward.length-1].stationing);
        if(!currentObject) break;

        let currentUtilizationRate;
        let utilizationRateDelta = ((vehicle.maxUtilizationRate + currentObject.slope * vehicle.maxUtilizationRateDelta) - (vehicle.minUtilizationRate + currentObject.slope * vehicle.minUtilizationRateDelta))/(vehicle.maxUtilizationRateSpeed - vehicle.minUtilizationRateSpeed);

        if(result.forward[result.forward.length-1].speed > vehicle.maxUtilizationRateSpeed) currentUtilizationRate = vehicle.maxUtilizationRate + currentObject.slope * vehicle.maxUtilizationRateDelta;
        else if(result.forward[result.forward.length-1].speed < vehicle.minUtilizationRateSpeed) currentUtilizationRate = vehicle.minUtilizationRate + currentObject.slope * vehicle.minUtilizationRateDelta;
        else currentUtilizationRate = (vehicle.minUtilizationRate + currentObject.slope * vehicle.minUtilizationRateDelta) + utilizationRateDelta * (result.forward[result.forward.length-1].speed - vehicle.minUtilizationRateSpeed);

        let tractionForce = vehicle.effect * currentUtilizationRate / (result.forward[result.forward.length-1].speed/3.6);
        let gravitationalForce = 9.81 * vehicle.mass * currentObject.slope;
        let rollingResistance = 9.81 * vehicle.mass * designFastVariables.rollingResistance;
        let airResistance = 0.5 * designFastVariables.airDensity * vehicle.airResistance * vehicle.frontArea * ((result.forward[result.forward.length-1].speed/3.6)**2);
        let forcesSum = tractionForce - gravitationalForce - rollingResistance - airResistance;
        let acceleration = forcesSum/vehicle.mass;

        if(result.forward[result.forward.length-1].speed/3.6 + acceleration * dt > vehicle.maxSpeed/3.6) acceleration = (vehicle.maxSpeed/3.6 - result.forward[result.forward.length-1].speed/3.6)/dt;
        if(result.forward[result.forward.length-1].speed/3.6 + acceleration * dt >= speedlimit/3.6) acceleration = (speedlimit/3.6 - result.forward[result.forward.length-1].speed/3.6)/dt;
    
        const newSpeed = result.forward[result.forward.length-1].speed + 3.6 * dt * acceleration;

        result.forward.push({
            speed: newSpeed,
            stationing: result.forward[result.forward.length-1].stationing + ((newSpeed/3.6) * dt) + (0.5 * acceleration * dt**2)
        });
    }

    while(result.backward[result.backward.length-1].stationing > geometry[0].stationing)
    {
        let currentObject = geometry.find(obj => obj.stationing >= result.backward[result.backward.length-1].stationing);
        if(!currentObject) break;

        let currentUtilizationRate;
        let utilizationRateDelta = ((vehicle.maxUtilizationRate + -currentObject.slope * vehicle.maxUtilizationRateDelta) - (vehicle.minUtilizationRate + -currentObject.slope * vehicle.minUtilizationRateDelta))/(vehicle.maxUtilizationRateSpeed - vehicle.minUtilizationRateSpeed);

        if(result.backward[result.backward.length-1].speed > vehicle.maxUtilizationRateSpeed) currentUtilizationRate = vehicle.maxUtilizationRate + -currentObject.slope * vehicle.maxUtilizationRateDelta;
        else if(result.backward[result.backward.length-1].speed < vehicle.minUtilizationRateSpeed) currentUtilizationRate = vehicle.minUtilizationRate + -currentObject.slope * vehicle.minUtilizationRateDelta;
        else currentUtilizationRate = (vehicle.minUtilizationRate + -currentObject.slope * vehicle.minUtilizationRateDelta) + utilizationRateDelta * (result.backward[result.backward.length-1].speed - vehicle.minUtilizationRateSpeed);

        let tractionForce = vehicle.effect * currentUtilizationRate / (result.backward[result.backward.length-1].speed/3.6);
        let gravitationalForce = 9.81 * vehicle.mass * -currentObject.slope;
        let rollingResistance = 9.81 * vehicle.mass * designFastVariables.rollingResistance;
        let airResistance = 0.5 * designFastVariables.airDensity * vehicle.airResistance * vehicle.frontArea * ((result.backward[result.backward.length-1].speed/3.6)**2);
        let forcesSum = tractionForce - gravitationalForce - rollingResistance - airResistance;
        let acceleration = forcesSum/vehicle.mass;

        if(result.backward[result.backward.length-1].speed/3.6 + acceleration * dt > vehicle.maxSpeed/3.6) acceleration = (vehicle.maxSpeed/3.6 - result.backward[result.backward.length-1].speed/3.6)/dt;
        if(result.backward[result.backward.length-1].speed/3.6 + acceleration * dt >= speedlimit/3.6) acceleration = (speedlimit/3.6 - result.backward[result.backward.length-1].speed/3.6)/dt;

        const newSpeed = result.backward[result.backward.length-1].speed + 3.6 * dt * acceleration;

        result.backward.push({
            speed: newSpeed,
            stationing: result.backward[result.backward.length-1].stationing - ((newSpeed/3.6) * dt) + (0.5 * acceleration * dt**2)
        });
    }

    return result;
}*/

export const calculateSpeedAlongVerticalProfile = ({verticalGeometry, vehicle, speedlimit, initialSpeed}) => {
    const dt = 0.1;
    const geometry = parseVerticalPoints(verticalGeometry);

    const maxSpeed = vehicle.maxSpeed;
    const mass = vehicle.mass;
    const effect = vehicle.effect;
    const airResistance = vehicle.airResistance;
    const frontArea = vehicle.frontArea;

    const maxUtil = vehicle.maxUtilizationRate;
    const minUtil = vehicle.minUtilizationRate;
    const maxUtilSpeed = vehicle.maxUtilizationRateSpeed;
    const minUtilSpeed = vehicle.minUtilizationRateSpeed;

    const maxUtilDelta = vehicle.maxUtilizationRateDelta;
    const minUtilDelta = vehicle.minUtilizationRateDelta;

    const rolling = designFastVariables.rollingResistance;
    const airDensity = designFastVariables.airDensity;

    const kmhToMs = 1 / 3.6;
    const msToKmh = 3.6;

    const startSpeed = initialSpeed ? initialSpeed : speedlimit;

    const forward = [{
        speed: startSpeed,
        stationing: geometry[0].stationing
    }];

    const backward = [{
        speed: startSpeed,
        stationing: geometry[geometry.length - 1].stationing
    }];

    // #region calculating forward
    let i = 0;
    let current = geometry[0];

    while(forward[forward.length - 1].stationing < geometry[geometry.length - 1].stationing)
    {
        const last = forward[forward.length - 1];

        while (i < geometry.length - 1 && last.stationing >= geometry[i + 1].stationing)
        {
            i++;
        }

        current = geometry[i];

        const speedMs = last.speed * kmhToMs;

        let util;

        if(last.speed > maxUtilSpeed) util = maxUtil + current.slope * maxUtilDelta;
        else if(last.speed < minUtilSpeed) util = minUtil + current.slope * minUtilDelta;
        else
        {
            const utilSlope =
                ((maxUtil + current.slope * maxUtilDelta) -
                (minUtil + current.slope * minUtilDelta)) /
                (maxUtilSpeed - minUtilSpeed);

            util =
                (minUtil + current.slope * minUtilDelta) +
                utilSlope * (last.speed - minUtilSpeed);
        }

        const tractionForce = effect * util / speedMs;
        const gravForce = 9.81 * mass * current.slope;
        const rollForce = 9.81 * mass * rolling;
        const aeroForce = 0.5 * airDensity * airResistance * frontArea * speedMs * speedMs;

        let acc = (tractionForce - gravForce - rollForce - aeroForce) / mass;

        const nextSpeedMs = speedMs + acc * dt;

        if(nextSpeedMs > maxSpeed * kmhToMs) acc = (maxSpeed * kmhToMs - speedMs) / dt;
        if(nextSpeedMs >= speedlimit * kmhToMs) acc = (speedlimit * kmhToMs - speedMs) / dt;

        const newSpeed = last.speed + msToKmh * dt * acc;

        forward.push({
            speed: newSpeed,
            stationing: last.stationing + speedMs * dt + 0.5 * acc * dt * dt
        });
    }

    // #endregion

    
    // #region calculating backward
    let j = geometry.length - 1;

    while(backward[backward.length - 1].stationing > geometry[0].stationing)
    {
        const last = backward[backward.length - 1];

        while(j > 0 && last.stationing <= geometry[j - 1].stationing)
        {
            j--;
        }

        current = geometry[j];

        const speedMs = last.speed * kmhToMs;

        let util;

        const slope = -current.slope;

        if(last.speed > maxUtilSpeed) util = maxUtil + slope * maxUtilDelta;
        else if(last.speed < minUtilSpeed) util = minUtil + slope * minUtilDelta;
        else
        {
            const utilSlope =
                ((maxUtil + slope * maxUtilDelta) -
                (minUtil + slope * minUtilDelta)) /
                (maxUtilSpeed - minUtilSpeed);

            util =
                (minUtil + slope * minUtilDelta) +
                utilSlope * (last.speed - minUtilSpeed);
        }

        const tractionForce = effect * util / speedMs;
        const gravForce = 9.81 * mass * slope;
        const rollForce = 9.81 * mass * rolling;
        const aeroForce = 0.5 * airDensity * airResistance * frontArea * speedMs * speedMs;

        let acc = (tractionForce - gravForce - rollForce - aeroForce) / mass;

        const nextSpeedMs = speedMs + acc * dt;

        if(nextSpeedMs > maxSpeed * kmhToMs) acc = (maxSpeed * kmhToMs - speedMs) / dt;
        if(nextSpeedMs >= speedlimit * kmhToMs) acc = (speedlimit * kmhToMs - speedMs) / dt;

        const newSpeed = last.speed + msToKmh * dt * acc;

        backward.push({
            speed: newSpeed,
            stationing: last.stationing - speedMs * dt + 0.5 * acc * dt * dt
        });
    }

    // #endregion

    return {
        forward,
        backward
    };
};
/*
export const calculateSpeedAlongVerticalProfile = ({
    verticalGeometry,
    vehicle,
    speedlimit,
    initialSpeed
}) => {

    const dt = 0.1;
    const geometry = parseVerticalPoints(verticalGeometry);

    const kmhToMs = 1 / 3.6;
    const msToKmh = 3.6;

    const maxSpeed = vehicle.maxSpeed;
    const mass = vehicle.mass;
    const effect = vehicle.effect;
    const airResistance = vehicle.airResistance;
    const frontArea = vehicle.frontArea;

    const maxUtil = vehicle.maxUtilizationRate;
    const minUtil = vehicle.minUtilizationRate;
    const maxUtilSpeed = vehicle.maxUtilizationRateSpeed;
    const minUtilSpeed = vehicle.minUtilizationRateSpeed;

    const maxUtilDelta = vehicle.maxUtilizationRateDelta;
    const minUtilDelta = vehicle.minUtilizationRateDelta;

    const rolling = designFastVariables.rollingResistance;
    const airDensity = designFastVariables.airDensity;

    const startSpeed = initialSpeed ? initialSpeed : speedlimit;

    const forward = [
        [geometry[0].stationing, startSpeed]
    ];

    const backward = [
        [geometry[geometry.length - 1].stationing, startSpeed]
    ];

    // =========================
    // FORWARD (O(N))
    // =========================

    let i = 0;

    while (forward[forward.length - 1][0] < geometry[geometry.length - 1].stationing) {

        const last = forward[forward.length - 1];

        while (i < geometry.length - 1 && last[0] >= geometry[i + 1].stationing) {
            i++;
        }

        const current = geometry[i];

        const speedMs = last[1] * kmhToMs;

        let util;

        if (last[1] > maxUtilSpeed) {
            util = maxUtil + current.slope * maxUtilDelta;
        } else if (last[1] < minUtilSpeed) {
            util = minUtil + current.slope * minUtilDelta;
        } else {
            const utilSlope =
                ((maxUtil + current.slope * maxUtilDelta) -
                 (minUtil + current.slope * minUtilDelta)) /
                (maxUtilSpeed - minUtilSpeed);

            util =
                (minUtil + current.slope * minUtilDelta) +
                utilSlope * (last[1] - minUtilSpeed);
        }

        const tractionForce = effect * util / speedMs;
        const gravForce = 9.81 * mass * current.slope;
        const rollForce = 9.81 * mass * rolling;
        const aeroForce = 0.5 * airDensity * airResistance * frontArea * speedMs * speedMs;

        let acc = (tractionForce - gravForce - rollForce - aeroForce) / mass;

        const nextSpeedMs = speedMs + acc * dt;

        if (nextSpeedMs > maxSpeed * kmhToMs) {
            acc = (maxSpeed * kmhToMs - speedMs) / dt;
        }

        if (nextSpeedMs >= speedlimit * kmhToMs) {
            acc = (speedlimit * kmhToMs - speedMs) / dt;
        }

        const newSpeed = last[1] + msToKmh * dt * acc;

        forward.push([
            last[0] + speedMs * dt + 0.5 * acc * dt * dt,
            newSpeed
        ]);
    }

    // =========================
    // BACKWARD (O(N))
    // =========================

    let j = geometry.length - 1;

    while (backward[backward.length - 1][0] > geometry[0].stationing) {

        const last = backward[backward.length - 1];

        while (j > 0 && last[0] <= geometry[j - 1].stationing) {
            j--;
        }

        const current = geometry[j];
        const slope = -current.slope;

        const speedMs = last[1] * kmhToMs;

        let util;

        if (last[1] > maxUtilSpeed) {
            util = maxUtil + slope * maxUtilDelta;
        } else if (last[1] < minUtilSpeed) {
            util = minUtil + slope * minUtilDelta;
        } else {
            const utilSlope =
                ((maxUtil + slope * maxUtilDelta) -
                 (minUtil + slope * minUtilDelta)) /
                (maxUtilSpeed - minUtilSpeed);

            util =
                (minUtil + slope * minUtilDelta) +
                utilSlope * (last[1] - minUtilSpeed);
        }

        const tractionForce = effect * util / speedMs;
        const gravForce = 9.81 * mass * slope;
        const rollForce = 9.81 * mass * rolling;
        const aeroForce = 0.5 * airDensity * airResistance * frontArea * speedMs * speedMs;

        let acc = (tractionForce - gravForce - rollForce - aeroForce) / mass;

        const nextSpeedMs = speedMs + acc * dt;

        if (nextSpeedMs > maxSpeed * kmhToMs) {
            acc = (maxSpeed * kmhToMs - speedMs) / dt;
        }

        if (nextSpeedMs >= speedlimit * kmhToMs) {
            acc = (speedlimit * kmhToMs - speedMs) / dt;
        }

        const newSpeed = last[1] + msToKmh * dt * acc;

        backward.push([
            last[0] - speedMs * dt + 0.5 * acc * dt * dt,
            newSpeed
        ]);
    }

    return { forward, backward };
};*/